module.exports = __webpack_public_path__ + "static/media/questionnaire-step1.11dcdfba.png";